import { Ability } from 'providers/casl'
import { FormVariant } from 'types/formVariant'
import { AbTest } from './types/abTest'

export const cannotEditAbTest = (
  variant: FormVariant,
  ability: Ability,
  status: AbTest['status'] | undefined,
): boolean => {
  const isDisabledByAuth: boolean =
    variant === 'add' ? ability.cannot('create', 'AbTests') : ability.cannot('update', 'AbTests')
  const isDisabledByStatus: boolean = status !== undefined && status !== 'draft'

  return isDisabledByAuth || isDisabledByStatus
}
